import { getFormattedDate } from "@mantine/dates";
import { createColumnHelper } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

import { ImageCell } from "#modules/quoteRequestLines/ImageCell";
import { PartCell } from "#modules/quoteRequestLines/PartCell";
import { QuoteRequestLinesListItem } from "#types/QuoteRequestLinesListItem";

const columnHelper = createColumnHelper<QuoteRequestLinesListItem>();

export const useQuoteRequestLinesTableColumns = () => {
  const { t } = useTranslation();

  return [
    columnHelper.accessor((quoteRequestLine) => quoteRequestLine.part.thumbnail, {
      id: "thumb",
      cell: ImageCell,
      header: "",
      enableHiding: true,
    }),

    columnHelper.accessor(() => "", {
      id: "partName",
      header: "",
      enableColumnFilter: true,
      cell: PartCell,
    }),

    columnHelper.accessor((quoteRequestLine) => quoteRequestLine.quoteRequest.reference ?? "-", {
      id: "reference",
      enableColumnFilter: true,
      header: t("qrl.table.reference"),
    }),

    columnHelper.accessor((quoteRequestLine) => quoteRequestLine.quoteRequest.client, {
      id: "client",
      header: t("qrl.table.client"),
    }),

    columnHelper.accessor(
      (quoteRequestLine) =>
        getFormattedDate({
          type: "default",
          date: new Date(quoteRequestLine.createdAt),
          locale: "fr-FR",
          format: "DD/MM/YYYY",
          labelSeparator: " ",
        }),

      {
        id: "createdAt",
        header: t("qrl.table.createdAt"),
      },
    ),

    columnHelper.accessor(
      (quoteRequestLine: QuoteRequestLinesListItem) => {
        if (quoteRequestLine.isBatch) {
          return t("qrl.batch.multipleQuantities");
        }

        return quoteRequestLine.quantity;
      },
      {
        id: "quantity",
        header: t("qrl.table.quantity"),
      },
    ),
  ];
};
